module.exports = __webpack_public_path__ + "img/196.e10baac0.jpg";